window.toggleTOC = function() {
    const tocContent = document.getElementById('tableOfContents');
    const tocHeader = document.querySelector('.toc-header');
    const arrow = document.querySelector('.toc-dropdown-arrow');
    
    if (tocContent && tocHeader && arrow) {
      tocContent.classList.toggle('show');
      tocHeader.classList.toggle('active');
      
      if (tocContent.classList.contains('show')) {
        arrow.style.transform = 'rotate(-180deg)';
      } else {
        arrow.style.transform = 'rotate(0deg)';
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const tocPlaceholder = document.getElementById('table-of-contents');
    if (!tocPlaceholder) return;
  
    const articleContent = document.querySelector('.article-content'); // 根据你的文章内容容器的类名调整
    if (!articleContent) return;
  
    const headers = articleContent.querySelectorAll('h2, h3');
    if (headers.length === 0) return;
  
    const toc = document.createElement('nav');
    toc.setAttribute('aria-label', 'Table of Contents');
    toc.className = 'toc-nav';
  
    const tocContainer = document.createElement('div');
    tocContainer.className = 'toc-container';
  
    const tocHeader = document.createElement('div');
    tocHeader.className = 'toc-header';
    tocHeader.innerHTML = '<span class="toc-title">Table of Contents</span><span class="toc-dropdown-arrow">▼</span>';
    tocHeader.onclick = window.toggleTOC;
  
    const tocContent = document.createElement('ul');
    tocContent.id = 'tableOfContents';
    tocContent.className = 'toc-content';
  
    headers.forEach((header, index) => {
      const headerText = header.textContent;
      const headerId = `toc-${index}`;
      header.id = headerId;
  
      const li = document.createElement('li');
      li.className = header.tagName.toLowerCase();
  
      const a = document.createElement('a');
      a.href = `#${headerId}`;
      a.textContent = headerText;
  
      li.appendChild(a);
      tocContent.appendChild(li);
    });
  
    tocContainer.appendChild(tocHeader);
    tocContainer.appendChild(tocContent);
    toc.appendChild(tocContainer);
  
    tocPlaceholder.appendChild(toc);
  });
  